import { SCREEN_SIZE } from 'global.enums';

export const calculateScreenSize = (width: number): keyof typeof SCREEN_SIZE => {
  switch (true) {
    case width >= SCREEN_SIZE.xl:
      return 'xl';
    case width >= SCREEN_SIZE.lg:
      return 'lg';
    case width >= SCREEN_SIZE.md:
      return 'md';
    case width >= SCREEN_SIZE.sm:
      return 'sm';
    case width >= SCREEN_SIZE.xs:
    default:
      return 'xs';
  }
};
